<div class="row mb-3" style="margin-top:65px" *ngIf="!isInline">
  <div class="col-12">
    <a [routerLink]="'/user-dashboard'">
      <i class="fas fa-fw fa-home me-2"></i>Home<i class="fas fa-fw fa-chevron-right mx-2"></i>
    </a>
    <a [routerLink]="'/admin/billing'">
      <i class="fas fa-fw fa-file-invoice-dollar me-2"></i>Billing Center<i class="fas fa-fw fa-chevron-right mx-2"></i>
    </a>
    <span class="c_bluedk"><i class="fas fa-fw fa-print mx-2"></i>QuickBooks Sync</span>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-12 col-md-6"><i class="fas fa-fw fa-cog me-2"></i>QuickBooks Sync</div>
          <div class="col-12 col-md-6 text-end">
          <!--<a [routerLink]="'/admin/billing-configuration'"><b><i class="fas fa-fw fa-cog me-2"></i>Billing Configuration</b></a>-->
          </div>
        </div>

      </div>
      <div class="card-body p-2">
        <div class="row">
          <div class="col-12 col-md-4 d-none">
            <label class="mb-1">Client(s)</label>
            <ng-multiselect-dropdown [placeholder]="'Select Client(s)'"
                                     [settings]="ddSettingsClients"
                                     [data]="filterClients"
                                     [(ngModel)]="clientList"
                                     (onSelect)="onClientSelect($event)"
                                     style="width:500px">
            </ng-multiselect-dropdown>

          </div>
          <div class="col-12 col-md-4">
            <ng-multiselect-dropdown [placeholder]="'Select Billing Period'"
                                     [settings]="ddSettingsPeriod"
                                     [data]="filterPeriods"
                                     [(ngModel)]="selectedPeriod"
                                     (onSelect)="onPeriodSelect($event)"
                                     style="width:250px">
            </ng-multiselect-dropdown>
          </div>
          <div class="col-12 col-md-6 pt-2">{{periodInfo}}</div>
          <div class="col-12 col-md-2">
            <button class="btn btn-sm btn-primary" (click)="runQBSync()">
              <i class="fas fa-fw fa-play me-2"></i>Go
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>
  
</div>
<div class="row mt-2">
  <div class="col-12">
    <div class="grid_sizer" id="sizeBatches" style="height:66vh">
      <ag-grid-angular class="ag-theme-alpine"
                       [rowData]="rowData"
                       [columnDefs]="columnDefs"
                       [getRowStyle]="getRowStyle"
                       [rowHeight]="28"
                       [headerHeight]="32"
                       (gridReady)="onGridReady($event)"
                       [rowSelection]="rowSelection"
                       (selectionChanged)="onSelectionChanged($event)"
                       [pagination]="false"
                       style="width: 100%;height:100%;border:0 !important">
      </ag-grid-angular>
    </div>
  </div>
</div>


<!-- MODAL markup -->
<div class="backdrop" data-bs-backdrop="true" [ngStyle]="{'display':showModal}"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':showModal}" id="minutesModal">
  <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="container-fluid p-0">
          <div class="row m-0 p-0">
            <div class="col-12 col-md-6 p-0 modal-title"></div>
            <div class="col-12 col-md-6 p-0 text-end">
              <button type="button" class="btn btn-sm btn-light my-1" alt="Close" title="Close" (click)="toggleModal('hide')">
                <i class="fas fa-fw fa-times"></i>
              </button>
            </div>
          </div>
        </div>
        <span></span>
      </div>
      <div class="modal-body">
        
      </div>
      <div class="modal-footer text-center d-none">
        <button type="button" class="btn btn-dark my-1" title="Save">
          <i class="fas fa-fw fa-save"></i>
        </button>
        <button type="button" class="btn btn-light my-1" alt="Close" title="Close">
          <i class="fas fa-fw fa-times"></i>
        </button>
      </div>
    </div>
  </div>
</div>
